import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import DeleteIcon from "@material-ui/icons/Delete";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";

import withStyles from "@material-ui/styles/withStyles";
//components
import ContentWrapper from "../../../containers/ContentWrapper";
//actions
import * as dialogActions from "../../../redux/actions/dialogactions";
import * as shootActions from "../../../redux/actions/shootsactions";
//constants
import * as shootTypes from "../../../redux/constants/ShootsActionTypes";
import CheckShootsTable from "./Table/CheckShootsTable";
import ShootsTable from "./Table/ShootsTable";

//colors
import amber from "@material-ui/core/colors/amber";
import red from "@material-ui/core/colors/red";
import QuestionsTable from "./Table/QuestionsTable";

const styles = themes => {
  return {
    dangerButton: {
      color: red[700],
      "&:hover": {
        backgroundColor: "rgba(211, 47, 47, 0.1)"
      }
    },
    warningButton: {
      color: "#fff",
      backgroundColor: amber[700],
      "&:hover": {
        backgroundColor: amber[800]
      }
    },
    containedDanger: {
      backgroundColor: red[700],
      "&:hover": {
        backgroundColor: red[800]
      }
    }
  };
};

class QuestionsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      data: [],
      fetching: true,
      fetched: false,
      selectedAll: false,
      approve: true,
      reject: true
    };
  }

  static getDerivedStateFromProps(props, state) {
    let selectedShots = props.data.filter(shot => shot.selected);
    let checkingStatusShots = selectedShots.filter(shot => !shot.checked).length;
    let checkedStatusShots = selectedShots.filter(shot => shot.checked && shot.approved).length;
    if (selectedShots.length === 0) return { approve: true, reject: true };
    else if (checkingStatusShots > checkedStatusShots) return { approve: false, reject: false };
    else if (checkedStatusShots === 0 && selectedShots.length > 0 && checkedStatusShots === 0) return { approve: false, reject: true };
    else if (checkedStatusShots === selectedShots.length) return { approve: true, reject: false };
    else {
      if (checkedStatusShots > selectedShots.length / 2) return { approve: false, reject: true };
      else if (checkedStatusShots < selectedShots.length / 2) return { approve: true, reject: false };
      else return { approve: false, reject: false };
    }
  }

  componentDidMount = () => {
    this.props.shootActions.getShootStatus(this.props.match.params.name, this.props.match.params.date);
    this.getQuestions();
  };

  componentDidUpdate(prevProps) {
    if (this.props.confirmDialog === false && prevProps.confirmDialog === true) {
      console.log("confirm model closed!: " + this.props.confirmAction);
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case "EDIT_QUESTIONS":
            this.setState({ edit: !this.state.edit });
            break;
          case shootTypes.SHOOTS_CANCEL_EDIT:
            this.setState({ edit: !this.state.edit });
            this.props.shootActions.resetSelectedQuestions();
            break;
          case shootTypes.SHOOTS_SAVE_PHOTO_SHOTS:
            this.setState({ edit: !this.state.edit });
            break;
          case "REMOVE_QUESTIONS":
            this.removeShots();
            break;
          case "ADD_QUESTION":
            this.props.history.push(`/shoots/add/${this.props.match.params.name}/${this.props.match.params.date}/add-question`);
            break;
          default:
            break;
        }
      }
    }
  }

  getQuestions = async () => {
    this.props.shootActions.getShootQuestions(this.props.match.params.name, this.props.match.params.date);
  };

  handleEditShots = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "Do you really want to to edit the current shots for this questions?",
      "EDIT_QUESTIONS"
    );
  };

  cancelEdit = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "Do you really want to to cancel the current shots for this questions?",
      shootTypes.SHOOTS_CANCEL_EDIT
    );
  };

  saveEdit = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "Do you really want to to save the current shots for this questions?",
      shootTypes.SHOOTS_SAVE_PHOTO_SHOTS
    );
  };

  markCheckShootComplete = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to mark the photo shots as checked. Please confirm if you want to do this action.",
      shootTypes.SHOOTS_PHOTO_SHOTS_CHECKED
    );
  };

  handleCheckbox = (data, selectedAll) => {
    this.setState({ data, selectedAll });
  };

  initiateRemoveShot = () => {
    let selectedQuestions = this.props.selectedQuestions;
    if (selectedQuestions.length > 0) {
      this.props.dialogActions.openConfirmDialog(
        "Are you sure?",
        `You are about remove ${selectedQuestions.length} selected questions. This actions is irreversible, please confirm if you want to do this action.`,
        "REMOVE_QUESTIONS"
      );
    }
  };

  removeShots = async () => {
    this.setState({
      fetching: true
    });
    let { name, date } = this.props.match.params;
    this.props.shootActions.removeQuestionsFromShoot(name, date);
  };

  initiateAddShotsToShoot = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to leave the page to add shots to this shoot. Please confirm if you want to do this action.",
      "ADD_QUESTION"
    );
  };

  handleSelectedAll = () => {
    this.props.shootActions.handleSelectAllCheckbox("photo");
  };

  handleApprove = () => {
    let checkedShots = this.props.data.filter(shot => shot.selected);
    console.log("Approve!");
    this.props.shootActions.handleApproveShots(this.props.match.params.name, this.props.match.params.date, "photo", checkedShots);
  };

  render() {
    const { classes } = this.props;
    const { date, name } = this.props.match.params;
    let selectedShots = this.props.selectedQuestions.length;
    return (
      <ContentWrapper>
        <Paper elevation={1} style={{ padding: "24px 0" }}>
          {this.props.status === null ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress color="primary" />
            </div>
          ) : this.props.data.length > 0 ? (
            <React.Fragment>
              {this.props.status === "DRAFT" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end"
                  }}
                >
                  {this.props.status === "DRAFT" &&
                    (this.state.edit ? (
                      <div
                        style={{
                          padding: "5px 24px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "row"
                        }}
                      >
                        <div>
                          <Button
                            variant="contained"
                            color="primary"
                            aria-label="Delete"
                            className={this.props.classes.containedDanger}
                            onClick={this.initiateRemoveShot}
                            disabled={selectedShots <= 0}
                          >
                            Remove
                            <DeleteIcon style={{ color: "inherit" }} />
                          </Button>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={this.cancelEdit}
                            className={this.props.classes.warningButton}
                            style={{ marginRight: 5 }}
                          >
                            Done Edit
                          </Button>
                          <Button variant="contained" color="primary" onClick={this.initiateAddShotsToShoot} style={{ marginLeft: 5 }}>
                            Add Questions
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ padding: "5px 24px" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleEditShots}
                          className={this.props.classes.warningButton}
                          style={{ marginRight: 5 }}
                        >
                          Edit Questions
                        </Button>
                        <Button variant="contained" color="primary" onClick={this.initiateAddShotsToShoot}>
                          Add Questions
                        </Button>
                      </div>
                    ))}
                </div>
              )}
              {/* {this.props.fetching && this.props.fetched ? <LinearProgress color="primary" style={{ height: 2 }} /> : null} */}
              <QuestionsTable
                questions={this.props.data}
                selectedQuestions={this.props.selectedQuestions}
                type={!this.state.edit ? "VIEW" : null}
                title="These are the added questions."
                positions={this.props.positions}
                handleShootQuestionCheckbox={this.props.shootActions.handleShootQuestionCheckbox}
                resetSelectedQuestions={this.props.shootActions.resetSelectedQuestions}
                setSelectedQuestions={this.props.shootActions.setSelectedQuestions}
                fetching={this.props.fetching}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              {this.props.fetching ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <CircularProgress color="primary" />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    padding: 50,
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"
                  }}
                >
                  <Typography component="span" variant="h3" color="inherit" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
                    No questions added
                  </Typography>
                  <Button variant="contained" color="primary" onClick={() => this.props.history.push(`/shoots/add/${name}/${date}/add-question`)}>
                    Add Questions
                  </Button>
                </div>
              )}
            </React.Fragment>
          )}
        </Paper>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed,
    status: state.selectedShoot.status,
    ...state.selectedShoot.details,
    ...state.selectedShoot.questions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

const StyledQuestionsTab = withStyles(styles)(QuestionsTab);

export default connect(mapStateToProps, mapDispatchToProps)(StyledQuestionsTab);
